import { FC } from 'react';
import { CurrentUser } from 'basics/types/user.types';
import { useCountrySelector } from 'modules/maya/components/CountrySelector/CountrySelector.hook';
import { useYodaCreateForm, YodaFormProvider } from 'services/yodaForm';
import Box from 'yoda-ui/Box';
import SelectYoda from 'yoda-ui/Form/SelectYoda';

type CountrySelectorProps = {
  user?: CurrentUser;
};
export const CountrySelector: FC<CountrySelectorProps> = ({ user }) => {
  const yodaFormMethods = useYodaCreateForm({ setIsValidOptional: true });
  const { countrySelectorConfig, handleCountryChange } = useCountrySelector(user);

  return (
    <YodaFormProvider { ...yodaFormMethods.providerFields }>
      <Box marginRight={ '50px' } width={ '250px' }>
        <SelectYoda disableClearable={ true } { ...countrySelectorConfig } onChange={ handleCountryChange } />
      </Box>
    </YodaFormProvider>
  );
};
